<template>
  <el-container>
    <fhead></fhead>
    <el-main>
      <el-breadcrumb class="center" separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">{{$t('l.home')}}</el-breadcrumb-item>
        <el-breadcrumb-item>Api</el-breadcrumb-item>
      </el-breadcrumb>
      <el-card class="box-card center" style="margin-top: 16px">
        <div slot="header" class="clearfix">
          <span>Api</span>
        </div>
        <el-collapse>
          <el-collapse-item v-for="v in list" v-bind:key="v" :title="v.title" :name="v.title">
            <el-link target="_blank" :href="v.link" type="primary">{{v.link}}</el-link>
            <el-table v-if="v.tableGetData" :data="v.tableGetData" style="width: 100%">
              <el-table-column prop="name" label="请求字段名"></el-table-column>
              <el-table-column prop="dsc" label="备注"></el-table-column>
            </el-table>
            <el-table v-if="v.tableData" :data="v.tableData" style="width: 100%">
              <el-table-column prop="name" label="返回字段名"></el-table-column>
              <el-table-column prop="dsc" label="备注"></el-table-column>
            </el-table>
          </el-collapse-item>
        </el-collapse>
      </el-card>
    </el-main>
    <el-footer class="footer">
      COPYRIGHT © 2018. ALL RIGHTS RESERVED. DESIGNED BY
      <a
        target="_blank"
        href="https://hebeblock.com/"
      >HEBEBLOCK</a>
    </el-footer>
  </el-container>
</template>


<script>
import fhead from "./../fhead.vue";

var load;

export default {
  name: "generators",
  components: {
    fhead
  },
  data() {
    return {
      list: [
          {
          title: "getState （获取节点状态）",
          link: "https://wallet.hebeblock.com/hebe?requestType=getState",
          tableData: [
            {
              name: "version",
              dsc: "节点版本"
            },
            {
              name: "services",
              dsc: "节点包含服务：API，CORS"
            },
            {
              name: "numberOfPeers",
              dsc: "同行数量"
            },
            {
              name: "numberOfActivePeers",
              dsc: "活跃同行数量"
            },
            {
              name: "isDownloading",
              dsc: "是否正在下载区块"
            }
          ]
        },
        {
          title: "getConstants （获取常量）",
          link: "http://wallet.hebeblock.com/hebe?requestType=getConstants",
          tableData: [
            {
              name: "epochBeginning",
              dsc: "区块开始时间"
            }
          ]
        },
        {
          title: "getAccount （根据地址获取信息）",
          link:
            "https://wallet.hebeblock.com/hebe?requestType=getAccount&account=HEBE-WDT8-UA4W-BSZY-DBCWT",
          tableData: [
            {
              name: "account",
              dsc: "账号id"
            },
            {
              name: "accountRS",
              dsc: "账号地址"
            },
            {
              name: "publicKey",
              dsc: "账号公钥"
            },
            {
              name: "balanceNQT",
              dsc: "账号币数量"
            },
            {
              name: "forgedBalanceNQT",
              dsc: "账号可锻造币数量"
            },
            {
              name: "unconfirmedBalanceNQT",
              dsc: "账号所有未确定的金额"
            },

            {
              name: "name",
              dsc: "账号名称，未设置该字段无"
            },
            {
              name: "description",
              dsc: "账号描述，未设置该字段无"
            }
          ]
        },
        {
          title: "getBlockchainTransactions （根据地址获取交易信息）",
          link:
            "https://wallet.hebeblock.com/hebe?requestType=getBlockchainTransactions&account=HEBE-WDT8-UA4W-BSZY-DBCWT&firstIndex=0&lastIndex=15",
          tableData: [
            {
              name: "amountNQT",
              dsc: "发送数量"
            },
            {
              name: "feeNQT",
              dsc: "手续费"
            },
            {
              name: "sender",
              dsc: "发送者id"
            },
            {
              name: "senderRS",
              dsc: "发送者地址"
            },
            {
              name: "recipient",
              dsc: "接受者id"
            },
            {
              name: "recipientRS",
              dsc: "接受者地址"
            },
            {
              name: "transaction",
              dsc: "交易id"
            },
            {
              name: "block",
              dsc: "区块id"
            },
            {
              name: "height",
              dsc: "交易高度"
            },
            {
              name: "confirmations",
              dsc: "区块确定数"
            },
            {
              name: "timestamp",
              dsc:
                "时间，需要获取getConstants接口中的epochBeginning：timestamp * 1000 + (epochBeginning - 500)"
            }
          ]
        },
        {
          title: "getAccountId （根据助记词获取信息，很危险，只建议本地使用）",
          link:
                  "https://wallet.hebeblock.com/hebe?requestType=getAccountId&secretPhrase=arrow familiar hop blue allow follow stroke heartbeat rabbit tide useless danger",
          tableData: [

            {
              name: "accountRS",
              dsc: "账号地址"
            },
            {
              name: "publicKey",
              dsc: "账号公钥"
            },
            {
              name: "description",
              dsc: "账号描述，未设置该字段无"
            }
          ]
        },
        {
          title: "getBlocks （获取所有区块信息，默认从最新区块开始）",
          link:
                  "https://wallet.hebeblock.com/hebe?requestType=getBlocks&firstIndex=0&lastIndex=5&includeTransactions=true",
          tableGetData: [
            {
              name: "block",
              dsc: "区块id"
            },
            {
              name: "previousBlockHash",
              dsc: "上一个区块hash"
            },
            {
              name: "previousBlock",
              dsc: "上一个区块"
            },
            {
              name: "numberOfTransactions",
              dsc: "区块交易数量"
            },
            {
              name: "payloadLength",
              dsc: "区块大小"
            },
            {
              name: "totalAmountNQT",
              dsc: "区块总交易数量"
            },
            {
              name: "totalFeeNQT",
              dsc: "区块总手续费"
            },
            {
              name: "transactions.sender",
              dsc: "发送者id"
            },
            {
              name: "transactions.senderRS",
              dsc: "发送者地址"
            },
            {
              name: "transactions.amountNQT",
              dsc: "发送金额"
            },
            {
              name: "transactions.feeNQT",
              dsc: "发送手续费"
            },
            {
              name: "transactions.recipient",
              dsc: "接收者id"
            },
            {
              name: "transactions.recipientRS",
              dsc: "接收者地址"
            },
            {
              name: "transactions.confirmations",
              dsc: "区块确定数"
            },
            {
              name: "transactions.transaction",
              dsc: "交易id"
            }
          ]
        },
        {
          title: "getTransaction （根据交易id获取信息）",
          link:
                  "https://wallet.hebeblock.com/hebe?requestType=getTransaction&transaction=16863763416914276919",
          tableGetData: [
            {
              name: "sender",
              dsc: "发送者id"
            },
            {
              name: "senderRS",
              dsc: "发送者地址"
            },
            {
              name: "amountNQT",
              dsc: "发送金额"
            },
            {
              name: "feeNQT",
              dsc: "发送手续费"
            },
            {
              name: "recipient",
              dsc: "接收者id"
            },
            {
              name: "recipientRS",
              dsc: "接收者地址"
            },
            {
              name: "confirmations",
              dsc: "区块确定数"
            },
            {
              name: "transaction",
              dsc: "交易id"
            }
          ]
        },
        {
          title: "getBlock （根据交易高度获取区块信息）",
          link: "https://wallet.hebeblock.com/hebe?requestType=getBlockgetBlock&height=0&includeTransactions=true",
        },
        {
          title: "sendMoney （获取未签名数据）",
          link: "https://wallet.hebeblock.com/hebe",
          tableGetData: [
            {
              name: "格式",
              dsc: "POST+FormData"
            },
            {
              name: "requestType:sendMoney",
              dsc: "请求类型"
            },
            {
              name: "publicKey:publicKey",
              dsc: "发送者公钥"
            },
            {
              name: "recipient:recipient",
              dsc: "接收人地址"
            },
            {
              name: "feeNQT:0",
              dsc: "手续费"
            },
            {
              name: "deadline:1440",
              dsc: "区块完全确定数"
            },
            {
              name: "普通消息",
              dsc: "无，可以不添加以下字段"
            },
            {
              name: "message:msg",
              dsc: "消息内容"
            },
            {
              name: "messageIsText:true",
              dsc: "消息是否为纯文本"
            },
            {
              name: "messageIsPrunable:true",
              dsc: "消息是否可修剪"
            },
            {
              name: "加密消息",
              dsc: "无，可以不添加以下字段"
            },
            {
              name: "encryptedMessageData:msg",
              dsc: "加密消息内容"
            },
            {
              name: "encryptedMessageNonce:nonce",
              dsc: "加密时的nonce"
            },
            {
              name: "messageToEncryptIsText:true",
              dsc: "加密消息是否为纯文本"
            },
            {
              name: "encryptedMessageIsPrunable:true",
              dsc: "加密消息是否可修剪"
            }
          ],
          tableData: [
            {
              name: "unsignedTransactionBytes",
              dsc: "未签名数据"
            },
            {
              name: "transactionJSON",
              dsc: "交易数据JSON"
            },
            {
              name: "transactionJSON.amountNQT",
              dsc: "交易数量"
            },
            {
              name: "transactionJSON.attachment",
              dsc: "附加消息，需要签名后再次发送"
            },
            {
              name: "transactionJSON.deadline",
              dsc: "完全确定区块"
            },
            {
              name: "transactionJSON.feeNQT",
              dsc: "手续费"
            },
            {
              name: "transactionJSON.height",
              dsc: "区块确定高度"
            },
            {
              name: "transactionJSON.recipient",
              dsc: "接受者id"
            },
            {
              name: "transactionJSON.recipientRS",
              dsc: "接受者地址"
            },
            {
              name: "transactionJSON.sender",
              dsc: "发送者id"
            },
            {
              name: "transactionJSON.senderPublicKey",
              dsc: "发送者公钥"
            },
            {
              name: "transactionJSON.senderRS",
              dsc: "发送者地址"
            }
          ]
        },
        {
          title: "sendMoney （助记词发送，很危险，只建议本地使用）",
          link: "https://wallet.hebeblock.com/hebe",
          tableGetData: [
            {
              name: "格式",
              dsc: "POST+FormData"
            },
            {
              name: "requestType:sendMoney",
              dsc: "请求类型"
            },
            {
              name: "publicKey:publicKey",
              dsc: "发送者公钥"
            },
            {
              name: "recipient:recipient",
              dsc: "接收人地址"
            },
            {
              name: "amountNQT:0",
              dsc: "发送数量（1个：是1*100000000）"
            },
            {
              name: "feeNQT:0",
              dsc: "手续费（设置为0由网络自动计算）"
            },
            {
              name: "secretPhrase:secretPhrase",
              dsc: "助记词"
            },
            {
              name: "deadline:1440",
              dsc: "区块完全确定数"
            },
            {
              name: "普通消息",
              dsc: "无，可以不添加以下字段"
            },
            {
              name: "message:msg",
              dsc: "消息内容"
            },
            {
              name: "messageIsText:true",
              dsc: "消息是否为纯文本"
            },
            {
              name: "messageIsPrunable:true",
              dsc: "消息是否可修剪"
            }
          ],
          tableData: [
            {
              name: "signatureHash",
              dsc: "签名hash"
            },
            {
              name: "transaction",
              dsc: "交易id"
            },
            {
              name: "broadcasted",
              dsc: "交易是否成功"
            }
          ]
        },
        {
          title: "broadcastTransaction （发送签名交易）",
          link: "https://wallet.hebeblock.com/hebe",
          tableGetData: [
            {
              name: "格式",
              dsc: "POST+FormData"
            },
            {
              name: "requestType:broadcastTransaction",
              dsc: "请求类型"
            },
            {
              name: "transactionBytes:transactionBytes",
              dsc: "签名交易"
            },
            {
              name: "prunableAttachmentJSON:transactionJSON.attachment",
              dsc: "如果有，请将transactionJSON.attachment添加"
            }
          ],
          tableData: [
            {
              name: "fullHash",
              dsc: "hash"
            },
            {
              name: "transaction",
              dsc: "交易id"
            }
          ]
        },
        {
          title: "hebejs （js签名数据库）",
          link: "https://github.com/HebePlatform/HebeJS"
        },

      ]
    };
  },
  methods: {},
  created: function() {}
};
</script>


<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/api/index.vue